<template>
  <main-bg class="reg-bg">
    <!-- 注册页 -->
    <div class="register">
      <h3 class="title">立即注册</h3>
      <div style="height:34px;"></div>
      <el-form :model="form" :rules="rules" ref="form"  @submit.native.prevent>

        <el-form-item prop="telephone" :error="telephoneErr">
          <el-input placeholder="请输入手机号码" v-model.trim="form.telephone" type="number" clearable auto-complete="new-password">
          <svg-icon icon="telephone" slot="prefix" size="24px"/>
        </el-input>
        </el-form-item>

        <el-form-item prop="telephone_code" :error="smsErr">
          <div class="code-input">
            <el-input placeholder="请输入验证码" v-model="form.telephone_code" auto-complete="new-password"/>
            <el-button class="code" @click="onGetSmsCode" :disabled="smsDisabled">{{ smsBtnText }}</el-button>
          </div>
        </el-form-item>

        <el-form-item prop="password" :error="passwordErr">
          <el-input placeholder="请输入密码" type="password" v-model="form.password" clearable auto-complete="new-password">
          <svg-icon icon="password" slot="prefix" size="24px"/>
        </el-input>
        </el-form-item>

        <template v-if="!isOEM">
          <p class="inv-user" v-if="invTelephone">邀请人 {{ invTelephone }}</p>
          <el-form-item :error="inviteCodeErr" v-else>
            <el-input placeholder="邀请码(选填)" v-model="form.inv_code" auto-complete="new-password"/>
          </el-form-item>
        </template>
        
        <zt-button type="primary" :loading="loading" :disabled="disabled" @click.enter.exact="onSubmit" native-type="submit">完成</zt-button>
        <router-link class="register-link" to="/">已有账号，立即登录></router-link>
      </el-form>

      <!-- 图形验证码弹框 -->
      <image-code-dialog :visible.sync="imgDialogVisible" :telephone="form.telephone" @success="onSuccess" api-type="reg"/>
    </div>
  </main-bg>
</template>

<script>
import { mapGetters } from 'vuex'
import ImageCodeDialog from '@/views/login/components/ImageCodeDialog'
import { countdownSeconds, sleep } from '@/utils/timer'
import { setToken, setRoles } from '@/utils/auth'
import { reg, taoke_info } from '@/api/login'
import mainBg from '@/views/layout/mainBg'


export default {
  name: 'Register',
  components: { ImageCodeDialog, mainBg},

  data: () => ({
    form: {
      telephone: '',
      telephone_code: '',
      password: '',
      inv_code: '', // 邀请码
    },
    rules: {
      telephone: [ { required: true, message: '请输入手机号码' } ],
      telephone_code: [ { required: true, message: '请输入验证码' } ],
      password: [ { required: true, message: '请输入密码' } ],
    },
    telephoneErr: '',
    smsErr: '',
    passwordErr: '',
    inviteCodeErr: '',

    loading: false,
    disabled: false,
    imgDialogVisible: false,

    smsCountdownTimer: null,
    smsBtnText: '获取验证码',
    smsDisabled: false,

    invTelephone: '',     // 邀请人手机号码
  }),
  computed: {
    // url参数带过来的邀请码
    urlCode() {
      return this.$route.query.inv_code || ''
    },
    ...mapGetters([ 'oemID', 'isOEM' ])
  },
  watch: {
    // code参数改变
    urlCode: {
      immediate: true,
      async handler(val) {
        if (this.isOEM) return

        if (val) {
          // 发请求
          const { data } = await taoke_info(val)
          
          if (data.error_code == 0) {
            this.invTelephone = data.info.telephone
          }
        }
        else {
          this.invTelephone = ''
        }

        this.form.inv_code = val
      }
    },

    "form.telephone"(val) {
      if (val.indexOf(" ") !== -1) {
        this.form.telephone = this.form.telephone.replace(/\s+/g, "");
      }
    },
    '$route.query.telephone': {
      immediate: true,
      handler(v) {
        if (v) {
          this.form.telephone = v
          this.form.password = ''
          this.telephone_code = ''
        }
      }
    },
  },

  methods: {
    // 注册
    onSubmit() {
      const { form } = this.$refs
      form.validate((valid) => {
        if (!valid) return false

        // 如果是OEM, 携带"oem_member_id"字段
        if (this.isOEM) {
          this.form.oem_member_id = this.oemID
        }
        
        this.loading = true
        reg({ ...this.form }).then(({ data }) => {
          const { error_code, error_message } = data

          // 手机号码无效 或 用户存在
          if (error_code == 1 || error_code == 3) {
            this.setErr('telephoneErr', error_message)
          }
          // 没输入密码
          else if (error_code == 2) {
            this.setErr('passwordErr', error_message)
          }
          // 短信验证码错误
          else if (error_code == 7) {
            this.setErr('smsErr', error_message)
          }
          else if (error_code != 0) {
            this.$message({
              type: 'error',
              message: error_message
            })
          }
          else {
            // 储存用户授权信息
            const sid = data.asid || data.tsid || data.csid
            setToken(sid)

            // 储存用户角色信息
            const role = data.asid ? 'admin' : 'taoke'
            setRoles([role])

            this.$message({
              type: 'success',
              message: '注册成功',
              duration: 900
            })
            sleep(() => {
              location.replace(process.env.VUE_APP_REDIRECT_URL) // 重定向页面
            }, 1200)
          }

          this.loading = false
        })
      })
    },

    // 获取短信验证码
    onGetSmsCode() {
      const { form } = this.$refs
      // 有手机号码就展示dialog
      form.validateField(['telephone'], (err) => {
        if (!err) {
          this.imgDialogVisible = true
        }
      })
    },

    // 短信验证码发送成功
    onSuccess() {

      // 倒计时60s
      clearInterval(this.smsCountdownTimer)
      this.smsCountdownTimer = countdownSeconds({
        current: (count) => {
          this.smsBtnText = count
          this.smsDisabled = true
        },
        lastone: () => {
          this.smsDisabled = false
          this.smsBtnText = '获取验证码'
        },
        count: 60
      })
    },


    // 设置err，修复重复错误无法重复提示
    setErr(name, error_message) {
      this[name] = ' '
      this.$nextTick(() => {
        this[name] = error_message
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@/styles/login.scss";

.inv-user {
  padding: 6px 0;
  font-size: 14px;
  color: $theme-textsecond;
  margin-bottom: 8px;
  padding-left: 4px;
}

</style>

/*
邀请逻辑：

1. 邀请注册的时候url会带上'code=xxx'的参数，其中xxx是邀请码
2. 通过邀请码拿到邀请人信息（头像、名称）
    - 能拿到邀请人信息：显示邀请人的信息在对应『邀请码输入框』的位置上
    - 拿不到邀请人信息：和不带code注册一致
 */